/* 4U on-card size picker (two-tap quick add) for touch screens.
   Tap the round + on a product card photo and the desktop hover Quick Add panel (same markup and styles
   as fu-cards.js / fu-cards.css) slides up with the sizes of the colour on that card, and the + moves
   into the panel's label row as its close (x). Tap a size and that exact variant goes in the cart,
   then the cart drawer opens (same add flow as the rest of the theme, so the free gift, tier bar and
   sale pricing all update).
   One-variant products add on the first tap. Sold-out sizes are shown struck through.
   Where assets/fu-quick-add.js is loaded it draws the + and this file takes over its tap; where it is
   not, this file draws the same + itself. Desktop with a mouse keeps the hover Quick Add in fu-cards.js.
   No product data is fetched until a + is tapped (then /products/<handle>.js once, cached).
   Also used for the Complete The Fit cards on product pages.
   Loaded by snippets/product-badges.liquid, and on product pages by layout/theme.liquid. */
(function () {
  if (window.fuQuickSize) return;
  var TOUCH = !!(window.matchMedia && (window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches));
  var PJ = {};
  var PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1.5v11M1.5 7h11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var cur = null; /* the open panel: { card, btn, panel } */
  /* Product cards, plus the Complete The Fit cards on product pages (snippets/complete-the-look-upgrade.liquid) */
  var CARD = '.product-card, .ctl-elite-item';

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var m = a ? (a.getAttribute('href') || '').match(/\/products\/([^\/?#.]+)/) : null;
    return m ? m[1] : '';
  }
  function getP(h) {
    if (!h) return Promise.resolve(null);
    if (!PJ[h]) {
      PJ[h] = fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { delete PJ[h]; return null; });
    }
    return PJ[h];
  }
  function optName(o) { return typeof o === 'string' ? o : ((o && o.name) || ''); }
  function optIndex(p, re) {
    var o = p.options || [];
    for (var i = 0; i < o.length; i++) if (re.test(optName(o[i]))) return i;
    return -1;
  }
  /* The colour the card is showing: active swatch, then the card's ?variant= link (pinned cards),
     then the colour label, then a colour named in the title. Always an exact option value. */
  function colourFor(card, p, ci) {
    if (ci < 0) return '';
    var key = 'option' + (ci + 1), values = [];
    p.variants.forEach(function (v) { if (v[key] && values.indexOf(v[key]) === -1) values.push(v[key]); });
    function exact(s) { s = String(s || '').toLowerCase().trim(); for (var i = 0; i < values.length; i++) if (values[i].toLowerCase() === s) return values[i]; return ''; }
    var sw = card.querySelector('.color-swatch.swatch--active[data-swap-colour]');
    if (sw && exact(sw.getAttribute('data-swap-colour'))) return exact(sw.getAttribute('data-swap-colour'));
    var cs = card.querySelector('.ctl-elite-swatch.active[data-color]');
    if (cs && exact(cs.getAttribute('data-color'))) return exact(cs.getAttribute('data-color'));
    var links = card.querySelectorAll('a[href*="variant="]');
    for (var j = 0; j < links.length; j++) {
      if (links[j].closest('.swatches, .product-card__bottom, .fu-qa')) continue;
      var m = (links[j].getAttribute('href') || '').match(/[?&]variant=(\d+)/);
      if (!m) continue;
      for (var k = 0; k < p.variants.length; k++) if (String(p.variants[k].id) === m[1] && p.variants[k][key]) return p.variants[k][key];
    }
    var c = card.querySelector('[data-colour-name], [data-role="color-label"]');
    if (c && exact(c.textContent)) return exact(c.textContent);
    var t = card.querySelector('[data-card-title-link], .product-card__title');
    var text = String(t ? t.textContent : '').toLowerCase(), best = '';
    values.forEach(function (v) { if (text.indexOf(v.toLowerCase()) > -1 && v.length > best.length) best = v; });
    return best || values[0] || '';
  }
  function variantsFor(p, ci, colour) {
    if (ci < 0 || !colour) return p.variants;
    var key = 'option' + (ci + 1);
    var list = p.variants.filter(function (v) { return String(v[key] || '').toLowerCase() === colour.toLowerCase(); });
    return list.length ? list : p.variants;
  }

  /* ---- Add to cart: the theme's own flow (bundled cart drawer sections, cart:updated, pubsub) ---- */
  function bundled() {
    var s = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: s } })); } catch (e) {}
    return s.filter(function (x, i) { return x && s.indexOf(x) === i; });
  }
  function swapSections(sec) {
    if (!sec) return;
    Object.keys(sec).forEach(function (id) {
      if (!sec[id]) return;
      var doc = new DOMParser().parseFromString(sec[id], 'text/html');
      ['MiniCart-', 'MainCart-'].forEach(function (pre) {
        var a = document.getElementById(pre + id), b = doc.getElementById(pre + id);
        if (a && b) a.innerHTML = b.innerHTML;
      });
    });
  }
  function openDrawer() {
    var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); return true; } catch (e) {} }
    var b = document.querySelector('.cart-drawer-button[aria-controls="CartDrawer"]');
    if (b) { b.click(); return true; }
    return false;
  }
  function add(id) {
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var sec = bundled();
    var path = window.location.pathname || '/';
    if (sec.length) { body.sections = sec; body.sections_url = path.charAt(0) === '/' ? path : '/'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || (typeof j.errors === 'string' ? j.errors : '') || ''); return j; }); })
      .then(function (j) {
        swapSections(j.sections);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('cart-count').forEach(function (c) { c.textContent = cart.item_count; if (cart.item_count > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (x) {}
          if (window.theme && theme.pubsub && theme.pubsub.publish && theme.pubsub.PUB_SUB_EVENTS) {
            try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fu-quick-size', cart: Object.assign({}, cart, { sections: j.sections || {} }) }); } catch (x) {}
          }
        });
      });
  }
  function errText(e) {
    var m = (e && e.message) || '';
    return m ? m.replace(/\s+/g, ' ').trim() : 'Could not add that size. Please try again.';
  }

  /* ---- Panel ---- */
  function close(instant) {
    if (!cur) return;
    var c = cur; cur = null;
    c.btn.classList.remove('fu-qs-on');
    c.btn.style.transform = '';
    c.btn.setAttribute('aria-expanded', 'false');
    c.btn.setAttribute('aria-label', 'Quick add');
    c.card.classList.remove('fu-qs-open');
    c.panel.classList.remove('is-in');
    if (instant) { c.panel.remove(); return; }
    setTimeout(function () { c.panel.remove(); }, 220);
  }
  function build(card, btn, p, vs, ci) {
    var si = optIndex(p, /size/i);
    var others = [];
    (p.options || []).forEach(function (o, i) { if (i !== ci) others.push(i); });
    var li = si > -1 ? si : (others.length === 1 ? others[0] : -1);
    function label(v) {
      if (vs.length === 1) return 'Add to cart';
      var l = li > -1 ? v['option' + (li + 1)] : others.map(function (i) { return v['option' + (i + 1)]; }).filter(Boolean).join(' / ');
      return (!l || l === 'Default Title') ? v.title : l;
    }
    /* Same markup as the desktop hover Quick Add in fu-cards.js, so it picks up the same styles */
    var panel = document.createElement('div');
    panel.className = 'fu-qa fu-qs';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Quick Add');
    panel.innerHTML = '<p class="fu-qa-label">Quick Add</p><div class="fu-qa-sizes"></div><div class="fu-qa-msg" aria-live="polite"></div>';
    var wrap = panel.querySelector('.fu-qa-sizes');
    var msg = panel.querySelector('.fu-qa-msg');
    var wide = false;
    vs.forEach(function (v) {
      var l = label(v);
      if (vs.length > 1 && String(l).length > 4) wide = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fu-qa-size' + (vs.length === 1 ? ' is-one' : '');
      b.textContent = l;
      b.setAttribute('aria-label', 'Add ' + p.title + (ci > -1 ? ' ' + v['option' + (ci + 1)] : '') + (vs.length > 1 ? ' size ' + l : '') + ' to cart');
      if (!v.available) { b.disabled = true; b.title = 'Sold out'; }
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (b.disabled || panel.__busy) return;
        panel.__busy = true;
        msg.textContent = '';
        b.classList.add('is-busy');
        b.textContent = '...';
        add(v.id).then(function () {
          b.classList.remove('is-busy');
          b.classList.add('is-done');
          b.textContent = '✓';
          setTimeout(function () {
            panel.__busy = false;
            if (cur && cur.panel === panel) close();
            if (!openDrawer()) window.location.href = '/cart';
            setTimeout(function () { b.classList.remove('is-done'); b.textContent = l; }, 300);
          }, 450);
        }).catch(function (x) {
          panel.__busy = false;
          b.classList.remove('is-busy');
          b.textContent = l;
          msg.textContent = errText(x);
        });
      });
      wrap.appendChild(b);
    });
    if (wide) panel.classList.add('fu-qs--wide');
    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
      panel.addEventListener(evt, function (e) { e.stopPropagation(); if (evt === 'click') e.preventDefault(); }, evt === 'touchstart' ? { passive: true } : false);
    });
    return panel;
  }
  function show(card, btn, p, vs, ci, err) {
    if (cur) close(true);
    var panel = build(card, btn, p, vs, ci);
    if (err) panel.querySelector('.fu-qa-msg').textContent = err;
    var box = btn.parentElement;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.insertBefore(panel, btn);
    cur = { card: card, btn: btn, panel: panel };
    /* Lift the + into the panel's label row (it turns into the x) */
    var lab = panel.querySelector('.fu-qa-label');
    var h = btn.offsetHeight || 34;
    var bottom = parseFloat(getComputedStyle(btn).bottom) || 8;
    var lift = bottom + h / 2 + lab.offsetTop + lab.offsetHeight / 2 - panel.offsetHeight;
    btn.style.transform = 'translateY(' + Math.min(0, Math.round(lift)) + 'px)';
    btn.classList.add('fu-qs-on');
    btn.setAttribute('aria-expanded', 'true');
    btn.setAttribute('aria-label', 'Close Quick Add');
    card.classList.add('fu-qs-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-in'); }); });
  }

  function openFor(card, btn) {
    if (cur && cur.card === card) { close(); return; }
    close();
    var h = handleOf(card);
    if (!h) return;
    btn.classList.add('is-busy');
    getP(h).then(function (p) {
      btn.classList.remove('is-busy');
      if (!p || !p.variants) { window.location.href = '/products/' + h; return; }
      var ci = optIndex(p, /colou?r/i);
      var vs = variantsFor(p, ci, colourFor(card, p, ci));
      if (vs.length === 1 && vs[0].available) {
        btn.classList.add('is-busy');
        add(vs[0].id).then(function () {
          btn.classList.remove('is-busy'); btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
          if (!openDrawer()) window.location.href = '/cart';
        }).catch(function (x) { btn.classList.remove('is-busy'); show(card, btn, p, vs, ci, errText(x)); });
        return;
      }
      show(card, btn, p, vs, ci, '');
    });
  }
  /* The + : take over the tap on fu-quick-add.js's button, or draw the same + where that file isn't loaded */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.fu-mqa-btn, .fu-qs-btn');
    if (!btn) return;
    var card = btn.closest(CARD);
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;
    openFor(card, btn);
  }, true);

  function decorate(card) {
    if (card.__fuQs) return;
    card.__fuQs = true;
    var ctl = card.classList.contains('ctl-elite-item');
    if (!ctl && (window.__fuMqa || card.querySelector('.fu-mqa-btn'))) return;
    var h = handleOf(card);
    if (!h || /gift/i.test(h)) return;
    if (card.closest('.fu-drp__soon')) return;
    if (card.querySelector('.quick-add button[disabled]')) return;
    var link = card.querySelector('.product-card__image-link, .ctl-elite-image-link');
    var box = link ? (link.parentElement && link.parentElement !== card ? link.parentElement : link) : null;
    if (!box) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fu-qs-btn';
    b.setAttribute('aria-label', 'Quick add');
    b.setAttribute('aria-expanded', 'false');
    b.innerHTML = PLUS;
    box.appendChild(b);
    card.classList.add('fu-qs-card');
  }
  function run() { if (TOUCH) document.querySelectorAll(CARD).forEach(decorate); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }

  /* Close: the + again, a tap outside, Escape, or a colour swatch on the same card */
  document.addEventListener('pointerdown', function (e) {
    if (!cur) return;
    if (cur.panel.contains(e.target) || cur.btn.contains(e.target)) return;
    close();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.color-swatch, .ctl-elite-swatch');
    if (sw && cur && sw.closest(CARD) === cur.card) close();
  }, true);

  window.fuQuickSize = { open: openFor, close: close };
})();